import GlobalNavbar from '../../../../components/feature/GlobalNavbar';

export default function Navbar() {
  return <GlobalNavbar />;
}
